import React, { PropsWithChildren } from 'react';
import { Colors } from './Colors';

import './Panel.scss';

type Props = {
    color?: Colors;
};

const Panel: React.FC<PropsWithChildren<Props>> = ({color, children}) => {
    
    const colorClass = color ? `bg-${color}` : ''; 

    return (
        <div className={colorClass}>
            {children}
        </div>
    );
};

export default Panel;